import { Dialog, DialogProps } from '@mui/material'
export interface MolsonDialogProps extends DialogProps {
  dataTestId?: string
}

export const MolsonDialog = ({
  dataTestId,
  children,
  ...props
}: MolsonDialogProps) => {
  return (
    <Dialog data-testid={dataTestId} disableScrollLock={true} {...props}>
      {children}
    </Dialog>
  )
}
